/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DataAiTools {
    None = '0',
    PowerBiQuery = 1,
    Charts = 2,
    All = 3,
}
